import { Reducer } from 'redux';

export const notificationReducer: Reducer<number[]> = (state = [], action) =>
    action.type === 'delete' ? action.data : state;
